import { c as _c } from "react/compiler-runtime";
import { LayoutContainer } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { isValidElement } from 'react';
import type { ContainerProps } from './types';
import './Container.scss';
export function Container(t0) {
  const $ = _c(7);
  const {
    items,
    topOfPage
  } = t0;
  const t1 = !topOfPage;
  let t2;
  if ($[0] !== t1) {
    t2 = cn("contentful-container", {
      "contentful-container__br-all": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items) {
    t3 = items?.filter(isValidElement);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <LayoutContainer className={t2}>{t3}</LayoutContainer>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}